const Homepage = require('./containers/Homepage');
const { context } = require('app-context');
const RoutingTable = require('services/auth-management/routing-table');

const selectors = context.selectors.all;
const redux = context.redux.hooks;

const internals = {};

// Sync route definition
module.exports = {
    path: '/',
    component: Homepage,
    exact: true,
    onWillMount: () => {

        const state = redux.getState();
        const isAuthenticated = selectors.getIsAuthenticated(state);
        const authStatus = selectors.getAuthStatus(state);

        if (isAuthenticated || internals.isAuthSettling(authStatus)) {
            return { replace: RoutingTable.getAppLoaderRoute() };
        }
    }
};

internals.isAuthSettling = (authStatus) => [
    selectors.AUTH_STATUSES.INIT,
    selectors.AUTH_STATUSES.WAITING
].includes(authStatus);
